<div class="block-wrapper">
  <div class="block-container">
    <app-mempool-block-overview [index]="index" [showFilters]="true"></app-mempool-block-overview>
  </div>
</div>